<template>
  <path
    d="M5 5.00024C5 5.55024 5.45 6.00024 6 6.00024H18C18.55 6.00024 19 5.55024 19 5.00024C19 4.45024 18.55 4.00024 18 4.00024H6C5.45 4.00024 5 4.45024 5 5.00024ZM7.41 14.0002H9V19.0002C9 19.5502 9.45 20.0002 10 20.0002H14C14.55 20.0002 15 19.5502 15 19.0002V14.0002H16.59C17.48 14.0002 17.93 12.9202 17.3 12.2902L12.71 7.70024C12.32 7.31024 11.69 7.31024 11.3 7.70024L6.71 12.2902C6.08 12.9202 6.52 14.0002 7.41 14.0002Z"
  />
</template>
